import classes from "./AboutModule.module.css";
import faceImg from "../img/FACE.png";
import { FaHtml5, FaCss3Alt, FaReact } from "react-icons/fa";
import {
  SiJavascript,
  SiCsharp,
  SiNextdotjs,
  SiMicrosoftsqlserver,
  SiDotnet,
} from "react-icons/si";
import { IconContext } from "react-icons";

const AboutModule = () => {
  const iconsStyles = {
    size: "2rem",
  };

  return (
    <IconContext.Provider value={iconsStyles}>
      <div className={classes.main_container}>
        <div className={classes.content}>
          <div className={classes.description}>
            <p className={classes.hola}>Hola!</p>
          </div>
          <div className={classes.middleContainer}>
            <div className={classes.tecnologias_section}>
              <h2 className={classes.exp_header}>Tecnologias Que Empleo</h2>
              <div className={classes.features_container}></div>
              <div className={classes.icons_container}>
                <div>
                  <p className={classes.highlight}>
                    <SiDotnet style={{ color: "#5C2D91" }} />
                  </p>
                  <p>.NET</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <SiCsharp style={{ color: "#68217A" }} />
                  </p>
                  <p>C#</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <SiJavascript style={{ color: "#f7cd1d" }} />
                  </p>
                  <p>JavaScript</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <FaReact style={{ color: "#3388ff" }} />
                  </p>
                  <p>React Js</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <SiNextdotjs style={{ color: "#000000" }} />
                  </p>
                  <p>Next.js</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <SiMicrosoftsqlserver style={{ color: "#CC2927" }} />
                  </p>
                  <p>SQL Server</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <FaHtml5 style={{ color: "#ff781f" }} />
                  </p>
                  <p>HTML</p>
                </div>
                <div>
                  <p className={classes.highlight}>
                    <FaCss3Alt style={{ color: "#3388ff" }} />
                  </p>
                  <p>CSS</p>
                </div>
              </div>
            </div>
            <div className={classes.experience_section}>
              <h2 className={classes.exp_header}>Mi experiencia:</h2>
              <h5>24/11/2023 - 24/05/2024</h5>
              <h3>-Desarrollador Full Stack (Americas BPS)</h3>
              <h5>Tech: .NET SQL SERVER</h5>
              <h3>Projectos personales:</h3>
              <h5>
                +5 <a href="/projects">ver projectos &rarr;</a>
              </h5>
              {/* <h5 className={classes.ver_detalle}>Ver detalle {"->"}</h5> */}
            </div>
          </div>
          <button
            className={classes.hv_button}
            onClick={() => window.open("./oscarcastro_hv.pdf", "_blank")}
          >
            Ver HV
          </button>
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default AboutModule;
